type AgentSessionsQueryInputs = Readonly<{
	sharingContext: string;
	aqlQuery: string;
}>;

export const createAgentSessionsQueryInputs = (
	accountId: string,
	rovoActivationId: string,
	includeLocalAgentSessions = false,
): AgentSessionsQueryInputs => {
	const rovoWorkspaceAri = `ari:cloud:rovo::workspace/${rovoActivationId}`;
	const escapedAccountId = accountId.replace(/\\/g, '\\\\').replace(/'/g, "\\'");

	return {
		sharingContext: rovoWorkspaceAri,
		aqlQuery: includeLocalAgentSessions
			? `authorAccountId = '${escapedAccountId}'`
			: `authorAccountId = '${escapedAccountId}' AND invocationType <> 'LOCAL_AGENT_SESSION'`,
	};
};
